import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';



import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useRef } from "react";
import AnimatedText from '../../components/AnimatedText/AnimatedText';

const HomeRouTech = () => {

   useEffect(() => {
      AOS.init();
      AOS.refresh();
   }, []);

   
   gsap.registerPlugin(useGSAP);
   gsap.registerPlugin(ScrollTrigger);


   useGSAP(() => {      

   });

   return (
      <div className="ruTech">
         <div className="ruTechImg">
            <img className="img-fluid dark-img" src={require("../../../assets/images/tech.png")} alt="" />
         </div>
         <div className="container container-cus1190">
            <div className="tknmsSecHd techHd">
               <h2 data-aos='fade-left' data-aos-duration="1000">ROU TECHNOLOGY</h2>
               <h3 data-aos='fade-right' data-aos-duration="1000">Get To know Us More</h3>               
            </div>
            <div className="tknmsSecBd">
               <div className="row nd-row">
                  <div className="col-lg-4 nd-col">
                     <div className="tknmsSecBdDts" data-aos={'fade-up'} data-aos-duration="500" data-aos-delay="50">
                        <div className="tknmsSecBdDtsBg">
                           <div className="tknmsSecBdDtsTp">
                              <div className="tknmsSecBdDtsTpL">
                                 <img className="img-fluid dark-img" src={require("../../../assets/images/tech1.png")} alt="" />
                              </div>
                              <h3>Routine Coin Smart Mining</h3>
                           </div>
                           <p>
                              This an innovative, energy-efficient alternative to traditional hardware mining. Unlike power-intensive mining methods, ROU tokens are mined and distributed in real-time on every MATIC ensuring a fair, transparent, and sustainable reward system.
                           </p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4 nd-col">
                     <div className="tknmsSecBdDts" data-aos={'fade-up'} data-aos-duration="700" data-aos-delay="150">
                        <div className="tknmsSecBdDtsBg">
                           <div className="tknmsSecBdDtsTp">
                              <div className="tknmsSecBdDtsTpL">
                                 <img className="img-fluid dark-img" src={require("../../../assets/images/tech2.png")} alt="" />
                              </div>
                              <h3>ROU members</h3>
                           </div>
                           <p>This unique approach allows only ROU members to participate in mining, eliminating the need for expensive hardware while promoting decentralization and accessibility.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4 nd-col">
                     <div className="tknmsSecBdDts" data-aos={'fade-up'} data-aos-duration="900" data-aos-delay="200">
                        <div className="tknmsSecBdDtsBg">
                           <div className="tknmsSecBdDtsTp">
                              <div className="tknmsSecBdDtsTpL">
                                 <img className="img-fluid dark-img" src={require("../../../assets/images/tech3.png")} alt="" />
                              </div>
                              <h3>Cost-effective and Eco-Friendly</h3>
                           </div>
                           <p>ROU offers a cost-effective, eco-friendly, and automated way to earn rewards—making crypto mining more efficient and inclusive than ever before.</p>
                        </div>
                     </div>
                  </div>


               </div>
            </div>
         </div>
      </div>
   )
}
export default HomeRouTech;